import { getUnownedProvidersOfUserApi } from 'api/user';
import { getAllCustom } from 'redux/crudCreatorCustom/actions';

export const MODEL_NAME = 'unownedProvidersOfUser';

export const getUnownedProvidersOfUser = getAllCustom(
  MODEL_NAME,
  getUnownedProvidersOfUserApi,
);
